import React from "react";
import { MessageContent } from "./MessageContent";

export const useGetAdminMessagesTableColumns = () => {
  return [
    {
      title: "Subject",
      render: (row) => row.Title,
    },
    {
      title: "Message",
      render: (row) => <MessageContent content={row.Content} />,
    },
    {
      title: "Type",
      render: (row) => row.Channels,
    },
    {
      title: "Sent on",
      render: (row) => row.CreatedDateString,
    },
    {
      title: "Sent by",
      render: (row) => row.AdminUser,
    },
    {
      title: "Recipients",
      render: (row) => row.RecipientsText,
    },
  ];
};
